import { reactive } from "vue";

export const pageTagStore = reactive({
    tags: [
        {
            name: "課本",
            color: "rgb(255, 135, 135)",
            type: "book"
        },
        {
            name: "習作",
            color: "rgb(128, 135, 47)",
            type: "study"
        },
        {
            name: "周邊資源",
            color: "rgb(101, 152, 255)",
            type: "resource"
        },
        {
            name: "影音頻道",
            color: "rgb(229, 146, 22)",
            type: "https://www.youtube.com/channel/UCbzOFvbPbnfAfp4lQwL3DbA/featured"
        }
    ],
    /**
     * 
     * @param {Array<{name: string, color:string, type:string}>} data 
     */
    setTags(data) {
        if(data) {
            this.tags = data;
        }
    }
});